import React from "react";

export const LazyMainPage = React.lazy(() => import("modules/projectRole/pages/MainPage"));
